import React, { forwardRef } from 'react';

import { Box } from '@mui/material';

import { DollarSmallIcon, PercentagesIcon } from '@setup/svg-icons/svg-icons';
import { MuiBaseTextFiled } from '@shared/ui-kit';

import NumberFormatCustom from './NumberFormatCustom';

type MuiCurrencyTextFiledProps = {
  isDisabled?: boolean;
  isRequired?: boolean;
  isReadOnly?: boolean;
  isFullWidth?: boolean;
  alwaysNegative?: boolean;
  alwaysPositive?: boolean;
  isError?: boolean;
  label?: string;
  inputVariant?: 'outline' | 'text';
  placeholder?: string;
  value?: number;
  helperText?: string;
  errorMessage?: string;
  size?: 'small' | 'medium';
  showPercentageIcon?: true;
  [x: string]: any;
};

export const MuiCurrencyTextFiled = forwardRef<HTMLHeadingElement, MuiCurrencyTextFiledProps>(
  (props, ref) => {
    const {
      isDisabled,
      isError,
      isFullWidth = true,
      isRequired,
      isReadOnly,
      errorMessage,
      label,
      alwaysNegative,
      alwaysPositive,
      placeholder,
      helperText,
      value,
      size,
      showPercentageIcon,
      ...args
    } = props;
    return (
      <Box
        sx={{
          label: {
            pointerEvents: 'initial',
          },
        }}
      >
        <MuiBaseTextFiled
          {...args}
          variant="outlined"
          label={label}
          inputRef={ref}
          fullWidth={isFullWidth}
          errorMessage={errorMessage}
          isDisabled={isDisabled}
          isRequired={isRequired}
          value={typeof value === 'number' ? value / 100 : value === null ? '' : value}
          isError={isError}
          placeholder={placeholder}
          helperText={helperText}
          isReadOnly={isReadOnly}
          size={size}
          inputProps={{
            readOnly: isReadOnly,
            inputProps: { alwaysNegative, alwaysPositive },
            inputComponent: NumberFormatCustom,
            startAdornment: showPercentageIcon ? <PercentagesIcon /> : <DollarSmallIcon />,
          }}
        />
      </Box>
    );
  },
);
